export const EMPLOYEE_SKILL_OPTIONS = [
    { value: "wartung", label: "Wartung" },
    { value: "elektriker", label: "Elektriker" },
    { value: "mechaniker", label: "Mechaniker" },
];

export const INVENTORY_ITEM_SKILL_OPTIONS = [
    { value: "elektriker", label: "Elektriker" },
    { value: "mechaniker", label: "Mechaniker" },
];

const SKILL_LABELS = EMPLOYEE_SKILL_OPTIONS.reduce(
    (labels, option) => ({ ...labels, [option.value]: option.label }),
    {}
);

export const skillOptions = (options, skills) =>
    options.filter((option) => (skills || []).includes(option.value));

export const skillLabels = (skills) =>
    (skills || []).map((skill) => SKILL_LABELS[skill] || skill).join(", ");
